module.exports = __webpack_public_path__ + "static/img/bg-light.82066e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw/bg-light.png
// module id = 5Nrw
// module chunks = 1